import { getAcceptLang } from './getAcceptLang';

export interface AuthTokens {
  token: string;
  refreshToken: string;
}

let inFlightRefresh: Promise<AuthTokens | null> | null = null;

const requestTokens = async (
  refreshToken: string
): Promise<AuthTokens | null> => {
  try {
    const url = `${import.meta.env.VITE_API_URL}/exec/api/auth/refresh`;

    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'accept-language': getAcceptLang() || 'ru',
      },
      body: JSON.stringify({ refreshToken }),
    });

    if (!response.ok) return null;

    const data = (await response.json()) as Partial<AuthTokens>;

    if (!data?.token || !data?.refreshToken) return null;

    return { token: data.token, refreshToken: data.refreshToken };
  } catch {
    return null;
  }
};

export const refreshTokens = (refreshToken: string) => {
  if (!inFlightRefresh) {
    inFlightRefresh = requestTokens(refreshToken).finally(() => {
      inFlightRefresh = null;
    });
  }

  return inFlightRefresh;
};
